//import low from 'lowdb';
import dimensions from './data';

/**
 * CSV parsed by - http://www.csvjson.com/csv2json
 * CSV got from - https://www.ispop.cz/magnoliaPublic/cenia-project/technicke_pozadavky/datove_standardy_aktualne/standardy-2015.html#jump7
 */
export default angular.module('countryDimensions', [])
	.service('countryDimensions', function() {
		this.dimensions = [];

		/**
		 * Set default storage and set values
		 */
		// let db = low('app/assets/countryDimensions.json');
		// db.defaults([]).value();

		// this.dimensions = db.getState();
		this.dimensions = dimensions;

		this.getDimensions = () => {
			return angular.copy(this.dimensions);
		};

		this.setDimensions = (dimensions) => {
			this.dimensions = angular.copy(dimensions);

		};
	}).directive('countrySelector', function() {
		return {
			template: `
				<a class="btn btn-{{ctrl.btnClass}}" uib-tooltip="{{ctrl.tooltip}}" ng-click="ctrl.openSelector()"><i class="fa fa-comment"></i></a>`,
			restrict: 'E',
			scope: {},
			replace: true,
			bindToController: {
				selectTo: '=',
				btnClass: '<',
				tooltip: '<',
				onSelect: '<'
			},
			controller: function(ngDialog, $scope, $timeout) {
				if (angular.isUndefined(this.tooltip)) {
					this.tooltip = 'Vybrat z číselníku';
				}

				if (angular.isUndefined(this.btnClass)) {
					this.btnClass = 'warning';
				}

				/**
				 * Open modal for changing password
				 */
				this.openSelector = () => {
					ngDialog.open({
						template: 'services/countryDimensions/selector.tpl.html',
						controller: function($scope, countryDimensions) {
							this.countryDimensions = countryDimensions.getDimensions();

							this.select = () => {
								if (angular.isDefined(this.selected)) {
									$scope.closeThisDialog({value: this.selected.originalObject});
								} else {
									$scope.closeThisDialog(false);
								}
							};
						},
						controllerAs: 'ctrl',
						name: 'countrySelectorDialog'
					}).closePromise.then((response) => {
						if (angular.isDefined(response.value.value)) {
							this.selectTo = response.value.value.kod;
							if (angular.isFunction(this.onSelect)) {
								this.onSelect(response.value.value);
							}
						}
					});
				};

				/**
				 * Ugly, dirty OMFG solution, but this autocomplete does not support programmatic focus
				 */
				$scope.$on('ngDialog.opened', function(e, dialog) {
					if (dialog.name == 'countrySelectorDialog') {
						$timeout(() => {
							document.querySelector('#_value').focus();
						});
					}
				});
			},
			controllerAs: 'ctrl'
		};
	}).name;



// WEBPACK FOOTER //
// build/services/countryDimensions/countryDimensions.js